module.exports = __webpack_public_path__ + "static/img/Pipa 40 cm joint sock 20cm.fb0f62c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Pipa 40 cm joint sock 20cm.jpg
// module id = 90
// module chunks = 1